import { Button } from "@mui/material";
import { StyledRecommendation } from "./Recommendation.styled";
import { UseFormReturn } from "react-hook-form";
import { AccountAdd } from "@models/account";
import { getToastErrorMessage } from "@shared/lib/errors"
import { toast } from 'react-toastify';
import { useLazyAccountRecommendationQuery } from "@features/tickets/api/accounts.api";


interface RecommendationProps{
    useForm?: UseFormReturn<AccountAdd>
}

function Recommendation({useForm}: RecommendationProps) {
    const [triggerRecommendation] = useLazyAccountRecommendationQuery();

    const sortCode: number | undefined = useForm?.getValues("sort_code");    

    async function handleRecommendation(sortCode: number): Promise<void> {

        const recommendationNumber: number = await triggerRecommendation(sortCode).unwrap();

        if(recommendationNumber>1){
            useForm?.setValue('account_number', recommendationNumber);
        }

        else{
            throw new Error("לא קיים כרטיס עם קוד המיון הנל");
        }

        
    }

    function recommendationButtonClicked(sortCode: number){
        toast.promise(
            handleRecommendation(sortCode),
            {
                error: {
                    render({data}) {
                        // When the promise reject, data will contains the error
                        return getToastErrorMessage(data);
                    }
                }
            }
        )
    }
    

    return (
        <StyledRecommendation>
            { useForm && <Button variant="outlined" disabled={!sortCode} onClick={()=>{ recommendationButtonClicked(sortCode!)}}>המלצה</Button> }
        </StyledRecommendation>
    )
}

export default Recommendation